<app-base-modal
  [title]="'Добавить ссылку'"
>
  <div class="container">
    <form
      [formGroup]="formGroup"
      class="form-container"
    >
      @for (field of createProfilesBloggerFormFields; track $index) {
        <mat-form-field appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          <input
            matInput
            type="text"
            [formControlName]="field.fieldName"
          >
        </mat-form-field>
      }
    </form>
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        [disabled]="!isValid()"
        (click)="handleProfileBloggerCreate()"
      >
        Сохранить
      </button>
      <button
        mat-button
        color="warn"
        (click)="closeDialog('cancel')"
      >
        Отменить
      </button>
    </div>
  </div>
</app-base-modal>
